import moment from 'moment';

export default (value, format) => {
  if (!value) return '';
  // moment.locale(locale);
  return moment.utc(value).local().format(format);
};



// WEBPACK FOOTER //
// ./src/filter/format-date.js